import dedicatedSetting from './dedicated-setting'
import dedicatedInfo from './dedicated-info'

export {
    dedicatedInfo,
    dedicatedSetting,
}